import { render, staticRenderFns } from "./发票开具.vue?vue&type=template&id=387db742&scoped=true&"
import script from "./发票开具.vue?vue&type=script&lang=js&"
export * from "./发票开具.vue?vue&type=script&lang=js&"
import style0 from "./发票开具.vue?vue&type=style&index=0&id=387db742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387db742",
  null
  
)

export default component.exports